/** Tiny platform boundary. CrazyGames SDK v3 wiring lives in sibling modules. */
export const platform = {
  id: 'local' as const,
};
